import styled from "@sonos-inc/web-ui-styled";
import { size, overflow, fontSize, fontWeight, textStyle, textAlign, colorStyle, flex, gridArea, gridRow, gridColumn, alignSelf, justifySelf, SonosTextColorProps, compose } from "styled-system";
import { color, height, padding, margin, width, position } from "@sonos-inc/web-ui-styled-system";
export var BlockStyles = compose(padding, margin, width, height, size, position, overflow, fontSize, fontWeight, textStyle, textAlign, colorStyle, color, flex, gridArea, gridRow, gridColumn, alignSelf, justifySelf);
/**
 * Block is a container that is the base component for all other components.  It supplies theme-based properties from styled-system
 */

export var Block = styled.div(BlockStyles);
Block.displayName = "Block";
export default Block;